// extracted by mini-css-extract-plugin
module.exports = {"avatar":"styles_avatar__1fRx2","avatar__img":"styles_avatar__img__2-UHW"};